import { createContext, useContext } from 'react';

export const DrawerContext = createContext({
    openDrawer: () => {},
    closeDrawer: () => {}
});

export const useDrawer = () => useContext(DrawerContext);
